module.exports = __webpack_public_path__ + "static/media/GF2.cd59e6e5.png";